import {Injectable} from '@angular/core';
import {WebsocketService} from '../../engine/websocket.service';
import {Store} from '@ngxs/store';

// import { SetViewersCount } from './store/actions';

@Injectable()
export class CounterService {
  constructor(private store: Store, private wsService: WebsocketService) {
    this.wsService.on('connected').subscribe(() => this.onConnected());
    this.wsService.on('viewers').subscribe(event => this.onViewers(event));
  }

  private _channel: string;

  set channel(value) {
    this._channel = value;
    this.getViewers();
  }

  sendEvent(name, data) {
    console.log({name, data});
    this.wsService.send('player_event_3', {name, data});
  }

  private onViewers({type, data}) {
    if (data.channel_id != this._channel) {
      return;
    }
    // this.store.dispatch(new SetViewersCount({viewers: data.count}));
  }

  private onConnected() {
    this.getViewers();
  }

  private getViewers() {
    if (!this._channel) {
      return false;
    }
    this.wsService.send('get_all_viewers', {channel: this._channel});
  }
}
